import React, { useContext, useState, useEffect } from "react";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import EmpPrimaryTab from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpPrimaryTab";
import NewsTicker from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/TCP-HP/NewsTicker";
import useEmpFar from "./UseEmpPurchasableFar";
import { useForm } from "react-hook-form";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import { Box, Button, OutlinedInput, Select, FormControl } from "@mui/material";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import RecommendationRemarksComponent from "../RecommendationComponent";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import BasicSiteInspectionReport from "../ScheduleInspection/basicSiteInspectionReport";
import SubStep1 from "../../citizen/AVPForms/formComponents/purchasable-Far/applicant-details/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/purchasable-Far/applicant-details/SubStep3";
import SubStep2 from "../../citizen/AVPForms/formComponents/purchasable-Far/applicant-details/SubStep2";
import CollapsibleHistory from "../NotingRemarks";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import PurchasableFarChecklist from "../../../components/EmployeeChecklist/PurchasableFarChecklist";
import ChecklistFarCitizen from "../../../components/CitizenChecklist/ChecklistFarCitizen";
import FarDetails from "../../../components/EmployeeFarDetails/FarDetails";
import ChatBoard from "../../../components/ChatBoard";
import ChatboardCorrespondenceApplicant from "../../../components/ChatBoard/ChatBoardApplicant/ChatBoardCorrespondenceApplicant";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import SubStep4 from "../../citizen/AVPForms/formComponents/purchasable-Far/applicant-details/SubStep4";
import CitizenFarDetails from "../../../components/CitizenFarDetails/CitizenFarDetails";
import { siteInspRecommendation } from "../../citizen/TCPForms/data";
import DetailInfoTable from "../AllViewRemarks";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import { ScrutinyRemarksContext } from "../../../../Context/remarks-data-context";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";

const EmpPurchasableFarPortal = ({ formData, workflowDetails, userRolesArray, workflow }) => {
  const { id } = useParams();

  // const isHideAction = ["REVERT_TO_APPLICANT", "APPROVED"]?.includes(formData?.status) && !isCitizen;
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);

  const {
    currentView,
    assignLTP,
    setAssignLTP,
    handleChange,
    currentTab,
    isPurchasableFAR,
    farDetails,
    setFarDetails,
    user,
    tenantId,
    updatedDocuments,
    setUpdatedDocuments,
    totalAmount,
    t,
    dispatch,
    applicationDocs,
    setMandatoryCondition,
    onRadioActionSelect,
    actions,
    handleChangePayment,
    showToast,
    setShowToast,
    closeToast,
    currentAction,
    setCurrentAction,
    fetchedPaymentData,
    setFetchedPaymentData,
    setRemarksData,
    handleRemarksValidation,
    developerRemarks,
    setDeveloperRemarks,
    userRoles,
    purchasableFarActions,
    developerRemarksValidation,
    ownerSubmit,
    purchasableFarSubmit,
    isCitizen,
    structureCertificateError,
    setPurchasableFarActions,
    applicationData,
    setReviewedData,
    onDropDownSelect,
    handleSubmit,
    isUserEligible,
    setIsUserEligible,
    isAssignedLTP,
    officesList,
    applicationFlow,
    initFormMTDocs,
    params,
    approvedLandUseData,
    approvedLayout,
    pFarList,
    handleDocView,
    setDeveloperRemarksDocument,
    developerRemarksDocument,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    documentRemarksData,
    documentSection,
    iframeSrc,
    setIframeSrc,
    initialUrl,
    setIsPreviewLoading,
    developerUpdateDocument,
    handleNoWorkflow,
  } = useEmpFar(formData, workflowDetails, userRolesArray, workflow);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const { control } = useForm();

  const subTabLabels = [{ label: "Verifying Authority" }, { label: "Applicant Details" }, { label: "Layout Details" }, { label: "Far Details" }];

  const handleTabChange = (nextTabNo, formData = null) => {
    console.log("nextTabReceived", nextTabNo, activeTab, isCitizen);

    if (formData) {
      const data = { ...params, ...formData };

      console.log(formData, params, data, "fromHandleTabCHange");

      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in formData)) {
        const data = { ...applicationData, ...formData };
        console.log("fromCreatePayload", data);

        Digit.OBPSService.createPurchasableFAR({ PurchasableFAR: data }, tenantId)
          .then((res) => {
            console.log(res.data, res, "promise");

            const result = res.PurchasableFAR?.[0];
            if (res?.PurchasableFAR?.length > 0) {
              onSelect("", { ...formData, ...result }, true);
              // Modal("Application Created.", `Application Created Successfully!`, "success");
              setShowToast({ key: "success", message: `Application Created Successfully!` });
              setActiveTab(nextTabNo);
              sessionStorage.setItem("currentTab", nextTabNo);
              Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
            }
          })
          .catch((e) => {
            setShowToast({ error: true, message: e?.response?.data?.Errors[0]?.message });
          });
      } else {
        try {
          if (activeTab === 4 && assignLTP === "No") {
            data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null }; // In case LTP is not assigned.
          } else if (activeTab === 4 && assignLTP === "Yes" && isAssignedLTP) {
            data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null }; // In case LTP is submitting the file
          } else if (activeTab === 4 && assignLTP === "Yes" && !isAssignedLTP) {
            data.workflow = { action: "FORWARD_TO_LTP", assignes: null }; // In case LTP is assigned and owner is submitting the file
          } else if (activeTab === 3) {
            data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
          } else {
            data.workflow = { action: "UPLOAD_DOC", assignes: [userUid] }; // Normal update call
          }

          updateApiCall.mutate(
            { PurchasableFAR: data },
            {
              onSuccess: () => {
                onSelect("", data);
                if (activeTab == 3) {
                  Modal(
                    "Application submitted.",
                    `Application <strong>${data?.applicationNo}</strong> Submitted Successfully!`,
                    "success",
                    "/digit-ui/citizen/profile",
                    closeModal
                  );
                  // setShowToast({ key: "success", message: `Application <strong>${data?.applicationNo}</strong> Submitted Successfully!` });
                  clearParams();
                  Digit?.SessionStorage.del("FORM_PURCHASABLE_FAR");
                  Digit?.SessionStorage.del("PURCHASABLE_FAR_TAB");
                  Digit?.SessionStorage.del("PURCHASABLE_FAR_SUBTAB");
                  // history.push("/digit-ui/citizen/profile");
                } else {
                  // Modal("Application Updated.", `Application Updated Successfully!`, "success");
                  setShowToast({ key: "success", message: `Application Updated Successfully!` });

                  setActiveTab(nextTabNo);
                  sessionStorage.setItem("currentTab", nextTabNo);
                  Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
                }
              },
              onError: (error) => {
                const errorObject = JSON.parse(error?.message);
                if (errorObject.code === "InvalidInputException") {
                  setShowToast({ error: true, message: `${errorObject.description}` });

                  // Modal("Invalid request.", `${errorObject.description}`, "error");
                }
              },
            }
          );
        } catch (error) {
          console.error(e);
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
      }
    } else {
      console.log("inside handle change else");
      if (assignLTP === "Yes" && nextTabNo === 2 && !isAssignedLTP) {
        setActiveTab(5);
        sessionStorage.setItem("currentTab", 5);
        Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", 5);
      } else {
        setActiveTab(nextTabNo);
        sessionStorage.setItem("currentTab", nextTabNo);
        Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
      }
    }
  };

  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);

    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              isEmployee={!isCitizen}
              isApproved={true}
              handleSubTabChange={handleSubTabChange}
              t={t}
              dispatch={dispatch}
              isUserEligible={isUserEligible}
              setIsUserEligible={setIsUserEligible}
              isAssignedLTP={isAssignedLTP}
              officesList={officesList}
              applicationFlow={applicationFlow}
              tenantId={tenantId}
              initFormMTDocs={initFormMTDocs}
              showToast={showToast}
              setShowToast={setShowToast}
            />
          );
        case 1:
          return (
            <SubStep2
              isEmployee={!isCitizen}
              isApproved={true}
              formData={params}
              handleSubTabChange={handleSubTabChange}
              t={t}
              isAssignedLTP={isAssignedLTP}
              applicationData={approvedLandUseData?.applicationData}
              approvedLayout={approvedLayout}
            />
          );
        case 2:
          return (
            <SubStep3
              isEmployee={!isCitizen}
              isApproved={true}
              formData={params}
              handleSubTabChange={handleSubTabChange}
              t={t}
              applicationFlow={applicationFlow}
              isAssignedLTP={isAssignedLTP}
              applicationData={approvedLandUseData?.applicationData}
              approvedLayout={approvedLayout}
              pFarList={pFarList}
            />
          );
        case 3:
          return (
            <SubStep4
              isEmployee={!isCitizen}
              isApproved={true}
              formData={params}
              handleTabChange={handleTabChange}
              handleSubTabChange={handleSubTabChange}
              t={t}
              isAssignedLTP={isAssignedLTP}
              applicationData={approvedLandUseData?.applicationData}
            />
          );
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      return (
        <React.Fragment>
          <div className="view-doc-container">
            <Button
              variant="contained"
              className="view-doc-btn"
              onClick={handleDocView}
              style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
            >
              <span className="view-doc-icon">
                <ViewSidebarIcon />
              </span>
              {currentView === "documents" ? "View all documents" : "View document section"}
            </Button>
          </div>
          {currentView === "documents" ? (
            <React.Fragment>
              <DocumentSection
                formData={params}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={updatedDocuments}
                handleChange={handleChange}
                attachedDocs={params?.documents || formData?.documents}
                handleNoWorkflow={handleNoWorkflow}
                setDataRecommendation={setDataRecommendationDocument}
                docType="mandatory"
                ComposableComponent={(props) => (
                  <RecommendationRemarksComponent
                    title="Recommendation Details"
                    label="Recommendation"
                    name="recommendation" // just a field name, not value!
                    options={SortingAlphabatically(siteInspRecommendation)}
                    defaultValue={dataRecommendationDocument}
                    extraLabel="Remarks"
                    setDeveloperRemarks={setDeveloperRemarksDocument}
                    developerRemarks={developerRemarksDocument}
                    setDataRecommendation={setDataRecommendationDocument}
                    {...props} // this includes `control`, injected later
                  />
                )}
              />
              {!isCitizen && <DetailInfoTable detailData={documentRemarksData?.DetailDataRemarks} type="documentDetails" />}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ViewDocuments
                documentSection={documentSection}
                setIsPreviewLoading={setIsPreviewLoading}
                iframeSrc={iframeSrc}
                setIframeSrc={setIframeSrc}
                initialUrl={initialUrl}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else if ((!isCitizen && activeTab === 2) || (isCitizen && activeTab === 1)) {
      return (
        <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName={"PURCHASABLE_FAR"} />
          <CollapsibleHistory formData={formData} />
          <OnSelectActionDropdown currentAction={currentAction || purchasableFarActions || " "} onChange={onDropDownSelect} actions={actions} />
          <RemarksEditor setRemarks={setDeveloperRemarks} remarks={developerRemarks} />
          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          <SubmitButton handleSubmit={purchasableFarSubmit} />
        </React.Fragment>
      );
    } else if ((!isCitizen && activeTab === 3) || (isCitizen && activeTab === 2)) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} />
        </React.Fragment>
      );
    } else if (activeTab === 4) {
      return (
        <React.Fragment>
          {!isCitizen && (
            <PurchasableFarChecklist
              formData={formData}
              lastEmpRole={userRolesArray?.[0]?.name}
              setRemarksData={setRemarksData}
              setCurrentTab={handleChange}
            />
          )}
        </React.Fragment>
      );
    } else if (activeTab === 5) {
      return (
        <React.Fragment>
          <FarDetails
            formData={formData}
            setCurrentTab={handleChange}
            farDetails={farDetails}
            setFarDetails={setFarDetails}
            empRole={userRolesArray?.[0]}
          />
        </React.Fragment>
      );
    } else if (activeTab === 6 || (isCitizen && activeTab === 3)) {
      return (
        <React.Fragment>
          {!isCitizen && <ChatBoard formData={formData} />}
          {isCitizen && <ChatboardCorrespondenceApplicant formData={formData} />}
        </React.Fragment>
      );
    }
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  return (
    <MainWrapper>
      <BackButton />
      {!isCitizen && <EmpTopBar formData={formData} />}
      {!isCitizen && <NewsTicker textForNews="Important:Please Save Far Circle Rate before Action Submission." />}
      <PrimaryTabsWrapper value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
          <PrimaryTab label="Application Form" />
          {!isCitizen && <PrimaryTab label="Document" />}
          <PrimaryTab label="Take Action" />
          <PrimaryTab label="All Remarks" />
          {!isCitizen && <PrimaryTab label="Checklist" />}
          {!isCitizen && <PrimaryTab label="FAR Details" />}
          <PrimaryTab label="Chat Board" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default EmpPurchasableFarPortal;
